var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordShowDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "password-show-dark",
    gradientUnits: "userSpaceOnUse",
    x1: 16.5,
    y1: 258,
    x2: 495.5,
    y2: 258,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00F2FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    style: {
      stopColor: "#03EFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#24D2FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#3CBDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    style: {
      stopColor: "#4AB0FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4FACFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#password-show-dark)"
    },
    d: "M128.5,326c11.046,0,20,8.954,20,20l0,0c0,11.046-8.954,20-20,20s-20-8.954-20-20l0,0 C108.5,334.954,117.454,326,128.5,326z M183.5,346L183.5,346c0,11.046,8.954,20,20,20s20-8.954,20-20l0,0c0-11.046-8.954-20-20-20 S183.5,334.954,183.5,346z M221.5,492c0,11.046-8.954,20-20,20h-105c-44.112,0-80-35.888-80-80V268c0-44.112,35.888-80,80-80h23.963 v-70.534C120.463,52.695,174.295,0,240.463,0s120,52.695,120,117.466V188H384.5c44.112,0,80,35.888,80,80v21 c0,11.046-8.954,20-20,20s-20-8.954-20-20v-21c0-22.056-17.944-40-40-40h-288c-22.056,0-40,17.944-40,40v164 c0,22.056,17.944,40,40,40h105C212.546,472,221.5,480.954,221.5,492z M160.463,188h160v-70.534c0-42.715-35.888-77.466-80-77.466 s-80,34.751-80,77.466L160.463,188L160.463,188z M491.864,426.498c-0.703,1.001-3.113,4.412-4.611,6.297 c-6.698,8.426-22.379,28.149-44.196,45.562C415.084,500.681,386.299,512,357.5,512s-57.585-11.319-85.557-33.644 c-21.819-17.414-37.498-37.137-44.192-45.559c-1.498-1.881-3.912-5.299-4.617-6.302c-4.846-6.898-4.845-16.096,0.002-22.994 c0.704-1.002,3.118-4.418,4.621-6.307c6.688-8.414,22.367-28.137,44.187-45.551C299.915,329.319,328.701,318,357.5,318 s57.585,11.319,85.557,33.645c21.817,17.412,37.497,37.136,44.193,45.558c1.499,1.885,3.911,5.299,4.614,6.3 C496.712,410.401,496.712,419.599,491.864,426.498z M450.143,415.001C418.343,377.169,387.203,358,357.5,358 c-29.707,0-60.843,19.165-92.642,57c31.801,37.836,62.937,57,92.642,57C387.206,472,418.342,452.835,450.143,415.001z M358.5,377 c-20.987,0-38,17.013-38,38s17.013,38,38,38s38-17.013,38-38S379.487,377,358.5,377z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShowDark);
export default __webpack_public_path__ + "static/media/PasswordShowDark.e57e6e78.svg";
export { ForwardRef as ReactComponent };